import { render } from "./TheHeader.vue?vue&type=template&id=3d97642f&ts=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=3d97642f&lang=css"

import exportComponent from "C:\\Users\\agui4\\Documents\\projects\\caner-server-status\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__